export const EXEMPT_TYPES = ['temp', 'beta', 'exempt', 'admin', 'affiliate'];
